import { useImperativeHandle, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { flatten } from 'lodash-es'
import { fieldFilter } from '../utils/fields'

const fileterSystemFields = (fields) => {
  if (!fields) {
    return []
  }

  return fields.filter(fieldFilter)
}

const dealFields = (fields, allFields, data) => {
  const productFields = flatten(
    fields
      .filter((v) => v && v.type === 'product')
      .map((v) => {
        const { productSlugs = [] } = v

        return allFields.filter((a) => productSlugs.includes(a.slug))
      })
  )
  // FIXME: 这部分其实是有些问题的, 我们数据结构如果设计的是好的, 按理说不需要这个方法
  // 我们应该先考虑从数据结构上解决这个问题
  if (fields) {
    return fields
      .map((obj) => {
        if (obj) {
          if (data && data[obj.slug]) {
            const value = data[obj.slug]
            return { ...obj, defaultValue: value }
          }
          if (obj.default && obj.default.value) {
            return { ...obj, defaultValue: obj.default.value }
          }
          if (obj.default && obj.type === 'button') {
            return { ...obj, defaultValue: obj.default }
          }
          if (obj.defaultChecked) {
            return {
              ...obj,
              defaultValue:
                obj.defaultChecked && obj.defaultChecked.length > 0
                  ? obj.defaultChecked
                  : obj.defaultValue,
              defaultChecked: null,
            }
          }
        }

        return obj || {}
      })
      .concat(productFields)
  }
  return []
}

const dealValidationRules = (
  fields,
  allFields,
  data,
  refConditonFields,
  ditto
) => {
  const shapeData = {}

  fields.forEach((opts) => {
    if (opts.hiddenWhenCreate) return
    const { type, slug } = opts
    const validation = ditto.validation(
      type,
      opts,
      allFields,
      data,
      refConditonFields
    )
    if (validation) {
      shapeData[slug] = validation
    }
  })
  return yup.object().shape(shapeData)
}

export default (
  { fields, allFields, data = {}, ditto, passValidation },
  ref
) => {
  const refConditonFields = useRef({})
  const editableFields = fileterSystemFields(
    dealFields(fields, allFields, data)
  )

  const props = {}
  if (!passValidation) {
    const schema = dealValidationRules(
      editableFields,
      allFields,
      data,
      refConditonFields.current,
      ditto
    )
    props.resolver = yupResolver(schema)
  }
  const {
    // register,
    control,
    handleSubmit,
    reset,
    setValue,
    watch,
    getValues,
    trigger,
    setError,
    clearErrors,
    unregister,
    formState: { errors },
    formState,
  } = useForm({
    defaultValues: data,
    ...props,
  })

  if (ref) {
    useImperativeHandle(ref, () => ({
      reset,
      getValues,
      slugs: editableFields.map((v) => v.slug),
      trigger,
    }))
  }

  return {
    // 可编辑或添加的字段
    refConditonFields,
    editableFields,
    // api
    watch,
    control,
    formState,
    errors,
    reset,
    unregister,
    getValues,
    handleSubmit,
    // hooks 封装
    formControl: {
      watch,
      setValue,
      getValues,
      clearErrors,
      setError,
    },
  }
}
